import { all } from 'redux-saga/effects';
import displayBoardSaga from './displayboard/saga';

export default function* rootSaga() {
    yield all([
        displayBoardSaga()
    ])
}